// extracted by mini-css-extract-plugin
export default {"iconStyle":"mMKsm2MjvtOHlHTfoi9mI","listStyle":"_2y9TH0W6-YGnS0h038tinK","submissionInformation":"_26uoCQn8BWb2yzOjxwY0D5"};